module.exports = __webpack_public_path__ + "img/Frueher-380.119d61c4.jpg";